import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

const Notebook = ({
  color = 'icon.primary',
  fill = 'transparent',
  ...props
}) => {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.0334 15.0075H3.69506C2.83516 15.0075 2.13867 14.311 2.13867 13.4511V2.55639C2.13867
           1.69648 2.83516 1 3.69506 1H13.0334C13.8933 1 14.5898 1.69648 14.5898 2.55639V13.4511C14.5898
           14.311 13.8933 15.0075 13.0334 15.0075Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={fill}
      />
      <Path
        d='M6.0293 4.8891H11.4767'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6.0293 11.1157H11.4767'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M6.0293 8.00238H11.4767'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M0.972656 4.8891H3.30724'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M0.972656 11.1157H3.15238'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M0.972656 8.00238H3.15238'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Notebook.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Notebook
